var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[(_vm.showSpinner)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"width":_vm.width,"size":_vm.size}}):_vm._e(),(_vm.showText)?_c('p',[_vm._v(_vm._s(_vm.$t(_vm.text)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }